window.cancelAnimationFrame = (function () {
  return (
    window.cancelAnimationFrame ||
    window.webkitCancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    window.oCancelAnimationFrame ||
    window.msCancelAnimationFrame ||
    function (id) {
      return window.clearTimeout(id);
    }
  );
})();
window.requestAnimationFrame = (function () {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function (callback) {
      return window.setTimeout(callback, 1000 / 60);
    }
  );
})();

function dataWarm(datas) {
  if (datas.length > 100) {
    console.warn(
      `数据达到了${datas.length}条有点多哦~,可能会造成部分老旧浏览器卡顿。`
    );
  }
}

function validator(value) {
  if (isNaN(value)) {
    console.warn("Must be in number format");
    return "0";
  }
  return value + "";
}

export { validator, dataWarm }
